export interface ITimezoneItem {
  name: string;
  tzCode: string;
}

export interface ITimezoneStore {
  selected: ITimezoneItem[];
  addTimezone: (tz: ITimezoneItem) => void;
  removeTimezone: (tzCode: string) => void;
}

export const MAX_TIMEZONES = 4;

export const INIT_TZS = [
  { name: 'London', tzCode: 'Europe/London' },
  { name: 'New York', tzCode: 'America/New_York' },
  { name: 'Prague', tzCode: 'Europe/Prague' },
  { name: 'Hong Kong', tzCode: 'Asia/Hong_Kong' },
];
